import { CoveoAnalyticsClient, } from "coveo.analytics/dist/browser.mjs";
import { clone } from '../../utils/utils.js';
export const getVisitorID = (options) => new CoveoAnalyticsClient(options).getCurrentVisitorId();
export const wrapPreprocessRequest = (logger, preprocessRequest) => {
    return typeof preprocessRequest === 'function'
        ? (...args) => {
            const untaintedOutput = clone(args[0]);
            try {
                return preprocessRequest.apply(preprocessRequest, args);
            }
            catch (e) {
                logger.error(e, 'Error in analytics preprocessRequest. Returning original request.');
                return untaintedOutput;
            }
        }
        : undefined;
};
export const wrapAnalyticsClientSendEventHook = (logger, hook) => {
    return (...args) => {
        const untaintedOutput = clone(args[1]);
        try {
            return hook.apply(hook, args);
        }
        catch (e) {
            logger.error(e, 'Error in analytics hook. Returning original request.');
            return untaintedOutput;
        }
    };
};
